<template>
  <div>
    <div class="row">
      <div class="col-4 metrics-title">
        <span class="metrics-label">Metrics Filters</span>
      </div>
      <div class="col-8 d-flex flex-column align-items-center">
        <div class="input-wrapper flex-row justify-content-between">
          <div
            style="width: 350px; height: 40px; white-space: nowrap"
            class="mr-2"
          >
            <el-radio-group
              class="concept-toggle"
              v-model="filters.metrics.rdfType.value"
              @change="(data) => $emit('refresh-options', data, 'rdfType')"
            >
              <el-radio-button label="all">All</el-radio-button>
              <el-radio-button label="rdf">Traditional</el-radio-button>
              <el-radio-button label="eeg">EEG</el-radio-button>
              <el-radio-button label="irt">IRT</el-radio-button>
            </el-radio-group>
          </div>
          <div
            style="width: 350px; height: 40px; white-space: nowrap"
            class="mr-2"
          >
            <el-radio-group
              class="concept-toggle"
              v-model="filters.metrics.useConcepts"
              @change="(data) => $emit('refresh-options', data, 'useConcepts')"
            >
              <el-radio-button :label="false">Fragrances</el-radio-button>
              <el-radio-button :label="true">Concepts</el-radio-button>
            </el-radio-group>
          </div>
          <div class="d-flex flex-column mr-3" style="width: 65%">
            <el-select
              v-model="filters.metrics.stage.value"
              collapse-tags
              placeholder="Stage"
              @change="updateDropdownValues(filters)"
            >
              <el-option-group label="Press Tab/Escape to exit">
                <el-option
                  v-for="value in getMetricsTagValues('stage')"
                  :key="value.name"
                  :label="value.name"
                  :value="value.name"
                >
                </el-option>
              </el-option-group>
            </el-select>
          </div>
          <div class="d-flex flex-column" style="width: 35%">
            <el-select
              v-model="filters.metrics.order.value"
              collapse-tags
              placeholder="Order"
              @change="updateDropdownValues(filters)"
            >
              <el-option-group label="Press Tab/Escape to exit">
                <el-option
                  v-for="value in getMetricsTagValues('order')"
                  :key="value.name"
                  :label="value.name"
                  :value="value.name"
                >
                </el-option>
              </el-option-group>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <hr class="mt-3" />
    <template v-for="(_, index) in filters.metrics.metricsList.length" :key="`metric-${index}`">
      <div class="row pb-2">
        <div class="col-10 d-flex">
          <div class="input-wrapper">
            <label>Metric type</label>
            <el-select
              v-model="filters.metrics.metricsList[index].metricType.value"
              placeholder="Select values"
              filterable
              collapse-tags
            >
              <el-option-group label="Press Tab/Escape to exit">
                <el-option
                  v-for="value in metricData(index).types"
                  :key="value"
                  :label="value"
                  :value="value"
                >
                  <span
                    v-if="value === 'Performance'"
                    v-b-tooltip.hover.html="tooltips.performance"
                    v-b-tooltip.left
                  >{{ value }}</span>
                  <span v-else>{{ value }}</span>
                </el-option>
              </el-option-group>
            </el-select>
          </div>
          <div class="input-wrapper mx-3">
            <label>Metric</label>
            <el-select
              :disabled="!filters.metrics.metricsList[index].metricType.value"
              v-model="filters.metrics.metricsList[index].metric.value"
              placeholder="Select values"
              filterable
              collapse-tags
            >
              <el-option-group label="Press Tab/Escape to exit">
                <el-option
                  v-for="value in metricData(index).options"
                  :key="value.field"
                  :label="
                    value.name === 'Believe' ? 'Believability' : value.name
                  "
                  :value="value.field"
                >
                </el-option>
              </el-option-group>
            </el-select>
          </div>
          <div class="input-wrapper">
            <label>Aggregation</label>
            <el-select
              :disabled="!filters.metrics.metricsList[index].metric.value"
              v-model="filters.metrics.metricsList[index].aggregation.value"
              placeholder="Select values"
              filterable
              collapse-tags
              @change="updateDropdownValues(filters)"
            >
              <el-option-group label="Press Tab/Escape to exit">
                <el-option
                  v-for="value in getFilteredMetricsTagValues('aggregations')"
                  :key="value.value"
                  :label="value.name"
                  :value="value.value"
                >
                </el-option>
              </el-option-group>
            </el-select>
          </div>
          <div class="input-wrapper" style="margin-left: 10px">
            <label>Calculate confidence</label>
            <el-checkbox
              v-model="filters.metrics.metricsList[index].confidence.value"
              style="border: 2px solid #8e8e8e; border-radius: 4px; padding: 8px"
            >
            <span style="padding: 10px">
              Use this metric
            </span>
            </el-checkbox>
          </div>
        </div>
        <div class="col-2">
          <div
            class="d-flex flex-row justify-content-end align-items-center mr-2"
            style="margin-top: 21px"
          >
            <button
              v-if="index === 0"
              class="btn btn-block btn-outline-success"
              @click="$emit('add-metric')"
              style="
                width: 29px;
                height: 29px;
                margin-top: 0;
                padding: 0;
                border-radius: 4px;
              "
              type="button"
            >
              <i class="el-icon-plus"></i>
            </button>
            <button
              v-else
              class="btn btn-block btn-outline-danger"
              @click="$emit('remove-metric', index)"
              style="
                width: 29px;
                height: 29px;
                margin-top: 0;
                padding: 0;
                border-radius: 4px;
              "
              type="button"
            >
              <i class="el-icon-delete"></i>
            </button>
          </div>
        </div>
      </div>
      <div
        class="row pb-2"
        v-if="filters.metrics.metricsList[index].applyThreshold"
      >
        <div class="col-10 d-flex flex-column mt-2">
          <div class="input-wrapper" style="width: unset !important">
            <div class="d-flex">
              <el-select
                v-model="
                  filters.metrics.metricsList[index].threshold.value.desc
                "
                collapse-tags
                placeholder="Select end"
                style="width: 200px"
                class="mr-3"
              >
                <el-option-group label="Press Tab/Escape to exit">
                  <el-option key="best" label="Best" :value="true"></el-option>
                  <el-option
                    key="worst"
                    label="Worst"
                    :value="false"
                  ></el-option>
                </el-option-group>
              </el-select>
              <el-input
                placeholder="Threshold"
                v-model="
                  filters.metrics.metricsList[index].threshold.value.amount
                "
                style="width: 200px"
                class="mr-3"
                clearable
              ></el-input>
              <el-select
                v-model="
                  filters.metrics.metricsList[index].threshold.value.type
                "
                collapse-tags
                placeholder="Threshold type"
              >
                <el-option-group label="Press Tab/Escape to exit">
                  <el-option
                    v-for="value in getMetricsTagValues('design_method')"
                    :key="value.value"
                    :label="value.value"
                    :value="value.value"
                  >
                    <span style="float: left">{{ value.value }}</span>
                    <span
                      style="float: right; color: #8492a6; font-size: 13px"
                      >{{ value.count }}</span
                    >
                  </el-option>
                </el-option-group>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-3" />
    </template>
    <div class="row pb-2">
      <div class="col-3 d-flex align-items-start">
        <div style="height: 40px" class="d-flex align-items-center mr-2">
          <span
            class="mr-2 threshold-text"
            :class="{
              'text-active': !filters.metrics.threshold.applyThreshold,
            }"
            >Apply threshold to search?</span
          >
          <ToggleButton
            class="toggle-switch"
            :labels="{ checked: 'Yes', unchecked: 'No' }"
            :color="{ checked: '#78BB95', unchecked: 'rgba(0, 0, 0, 0.15)' }"
            :sync="true"
            v-model="filters.metrics.threshold.applyThreshold"
          ></ToggleButton>
        </div>
      </div>
      <div class="col-9 d-flex flex-column">
        <div
          class="input-wrapper threshold"
          :class="{ 'is-visible': filters.metrics.threshold.applyThreshold }"
          style="width: unset !important"
        >
          <div class="d-flex">
            <el-select
              v-model="filters.metrics.threshold.desc"
              collapse-tags
              placeholder="Select end"
              style="width: 200px"
              class="mr-3"
            >
              <el-option key="best" label="Best" :value="true"></el-option>
              <el-option key="worst" label="Worst" :value="false"></el-option>
            </el-select>
            <el-input
              placeholder="Threshold"
              type="number"
              v-model="filters.metrics.threshold.amount"
              style="width: 200px"
              class="mr-3"
              clearable
            ></el-input>
            <el-select
              v-model="filters.metrics.threshold.type"
              collapse-tags
              placeholder="Threshold type"
            >
              <el-option
                v-for="value in getMetricsTagValues('threshold')"
                :key="value.value"
                :label="
                  filters.metrics.useConcepts && value.name === 'Fragrances'
                    ? 'Concepts'
                    : value.name
                "
                :value="value.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToggleButton from '@/components/shared/ToggleButton'
import tooltips from '../../../constants/tooltips'

export default {
  name: 'MetricsForm',
  components: { ToggleButton },
  props: {
    filters: Object,
    updateDropdownValues: Function,
    removeAppliedFilter: Function,
    getMetricsTagValues: Function,
    metricsAreFilled: Boolean
  },
  data () {
    return {
      useMetric: false,
      tooltips,
      rdfType: ''
    }
  },
  computed: {
    thresholdCorrect () {
      const {
        applyThreshold,
        amount,
        type
      } = this.filters.metrics.threshold
      return applyThreshold ? amount && type : true
    }
  },
  methods: {
    metricData (index) {
      const metrics = this.getMetricsTagValues('metrics')
      const data = {}
      if (this.filters.metrics.rdfType.value === 'eeg') {
        data.types = [...new Set(metrics.map(item => item.type))]
          .filter(item => ['Performance'].includes(item))
      } else {
        data.types = [...new Set(metrics.map((item) => item.type))]
          .filter(
            item => !['Attribute: ethnicity '].includes(item))
      }
      data.options = metrics.filter(
        (el) =>
          el.type === this.filters.metrics.metricsList[index].metricType.value
      )
      if (!this.filters.metrics.useConcepts &&
          this.filters.metrics.metricsList[index].metricType.value === 'Performance') {
        if (this.filters.metrics.rdfType.value === 'rdf') {
          data.options = data.options.filter((el) => {
            return ['liking', 'strength', 'purchase_intention'].includes(el.field)
          })
        } else if (this.filters.metrics.rdfType.value === 'eeg') {
          data.options = data.options.filter((el) => {
            return [
              'hfd_hedonic',
              'addiction',
              'cogproc',
              'attention',
              'relaxation',
              'energizing'
            ].includes(el.field)
          })
        } else {
          data.options = data.options.filter((el) => {
            return [
              'liking',
              'strength',
              'purchase_intention',
              'hfd_hedonic',
              'addiction',
              'cogproc',
              'attention',
              'relaxation',
              'energizing'
            ].includes(el.field)
          })
        }
      }
      return data
    },
    uncheckThresholdToggle () {
      this.$set(this.filters.metrics.threshold, 'applyThreshold', false)
    },
    getFilteredMetricsTagValues (tag) {
      if (this.filters.metrics.rdfType.value === 'eeg' && tag === 'aggregations') {
        return this.getMetricsTagValues(tag).filter(
          (el) => el.value === 'mean'
        )
      } else if (this.filters.metrics.rdfType.value === 'irt' && tag === 'aggregations') {
        return this.getMetricsTagValues(tag).filter((el) => {
          return ['mean', 'hi_yes', 'hi_no', 'irt_yes', 'irt_no'].includes(el.value)
        })
      } else {
        return this.getMetricsTagValues(tag).filter((el) => {
          return !['hi_yes', 'hi_no', 'irt_yes', 'irt_no'].includes(el.value)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variables";

.input-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}

.input-wrapper.flex-row {
  flex-wrap: wrap;
  align-items: center;
  overflow: visible;
  gap: 4px;
}

.input-wrapper.flex-row > * {
  flex: 0 0 auto;
}

.input-wrapper.flex-row > .mr-2 {
  width: auto !important;
  height: auto !important;
}

.input-wrapper.flex-row > .mr-3 {
  width: auto !important;
  flex: 0 0 auto;
}

.input-wrapper.flex-row > .mr-3,
.input-wrapper.flex-row > .d-flex.flex-column {
  width: 140px !important;
}

.threshold {
  height: 0;
  overflow: hidden;
  transition: height 0.2s ease-in-out;
}

.threshold.is-visible {
  height: 40px !important;
}

.input-wrapper input {
  width: 100%;
}

.input-wrapper .el-select {
  width: 100%;
}

.input-wrapper label {
  color: $input-label;
  margin-bottom: 2px;
  margin-left: 2px;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 13px;
  line-height: 20px;
  font-weight: 600;
}

.metrics-label {
  color: rgba(0, 0, 0, 0.17);
  font-size: 1.4rem;
}

.metrics-title {
  margin: auto 0;
}

.toggle-switch {
  margin-bottom: 0;
}

.threshold-text {
  font-size: 13px;
  color: #78bb95;
  transition: color 0.2s linear;
  white-space: nowrap;
}

.text-active {
  color: rgba(0, 0, 0, 0.2);
}

.confidence-radio {
  border-color: grey;
  color: grey;
}
</style>
<style lang="scss">
.concept-toggle {
  display: inline-flex;
  flex-wrap: wrap;
  white-space: nowrap;
  gap: 0;

  .el-radio-button {
    flex: 0 0 auto;
  }

  .el-radio-button__inner {
    padding: 2px 8px !important;
    height: 40px;
    font-size: 16px !important;
    line-height: 26px !important;
    white-space: nowrap;
  }
}
</style>
